import { render, staticRenderFns } from "./NhstResetPasswordComplete.vue?vue&type=template&id=1cc8610a"
import script from "./NhstResetPasswordComplete.vue?vue&type=script&lang=js"
export * from "./NhstResetPasswordComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports